<template>
  <div class="position-relative">
    <div v-if="isError" class="error">{{ errorMsg }}</div>
    <div v-if="isLoading" style="padding: 20px; position: absolute; top:0px; right: 10px;">
      <img :src="loadingUrl" style="vertical-align: middle"> {{ $t('nwp.loading_chart') }}...
    </div>

    <div style="display: none">
      <template v-if="isStationsLoaded">
        <form method="get" id="form" action="?">
          <label for="station" class="w125 fl tr">{{ $t('nwp.vyberte_mesto') }}:</label>
          <div class="fl">
            <v-select2 v-model="selectedStation" id="stationType"
                       :options="stationsOptions"
                       :settings="{...defaultSelect2Settings, allowClear: false, minimumResultsForSearch: 1, width: '250px'}"
                       @open="focusStationInput"
            >
            </v-select2>
          </div>
          <button v-if="isGeolocationEnabled" @click="selectStationByLocation" title="Vybrať najbližšie miesto" class="fl p-2" style="padding-bottom: 5px !important;" type="button"><i class="icon-location2"></i></button>


          <template v-if="isProductsLoaded && stationProductsTypes !== null">

            <label for="timeSelector" class="w100 fl ml-3 tr">{{ $t('nwp.predpoved_z') }}:</label>
            <select v-model="selectedRuntime" name="timeSelector" id="timeSelector" class="w150 fl">
              <template v-for="runtime in stationRuntimes">
                <option :value="runtime">{{ showDateTimeTZ(runtime * 1000, 'DD.MM.YYYY HH:mm') }}</option>
              </template>
            </select>

            <label for="heightSelector" class="w100 fl tr">{{ $t('nwp.vyska_grafu') }}:</label>
            <select v-model="selectedHeight" name="heightSelector" id="heightSelector" class="w125 fl">
              <template v-for="height in chartHeights">
                <option :value="height.value">{{ height.name }}</option>
              </template>
            </select>

            <label for="utcSelector" class="w50 fl tr">{{ $t('nwp.cas') }}:</label>
            <select v-model="selectedTZ" name="utcSelector" id="utcSelector" class="w100 fl">
              <option value="utc">UTC</option>
              <option value="local">{{ $t('nwp.lokalny') }}</option>
            </select>


            <div class="clearfix"></div>
            <div class="d-flex align-items-center box-vars justify-content-between">
              <label class="text-right mr-0">{{ $t('nwp.zobrazit_veliciny') }}:</label>
              <div class="d-flex align-items-center" v-for="variable in vars">
                <input class="d-block" style="cursor: pointer" type="checkbox" v-model="checkedVars" :id="`ch_`+variable.id" :value="variable.id">
                <label :for="`ch_`+variable.id" class="d-block">{{  variable.name }}</label>
              </div>
            </div>

          </template>

          <div class="clearfix"></div>
        </form>
      </template>
    </div>

    <template v-if="isProductsLoaded">

      <div class="text-center pb-3 pt-4 d-flex justify-content-center" id="btn">
        <template v-for="productType in stationProductsTypes">
          <a :key="productType" @click="selectedType=productType" :class="['button', 'meteogram-btn', (selectedType===productType) ? 'selected' : '']">{{ nicename(productType) }}</a>
        </template>
        <div class="clearfix"></div>
      </div>

      <div v-if="selectedType === 'ecmwf'">
        <ecmfw-eps-chart @isChartLoading="updateIsChartLoading"
                         :tz="selectedTZ"
                         :height="selectedHeight"
                         :vars="checkedVars"
                         :json_station="stationMeta"
                         :json_type="selectedType"
                         :selected_runtime="selectedRuntime"
                         :json_data_multi="productJsonArr"></ecmfw-eps-chart>
      </div>
      <div v-else-if="selectedType === 'alaef'">
        <alaef-eps-chart @isChartLoading="updateIsChartLoading"
                         :tz="selectedTZ"
                         :height="selectedHeight"
                         :vars="checkedVars"
                         :json_station="stationMeta"
                         :json_type="selectedType"
                         :selected_runtime="selectedRuntime"
                         :json_data_multi="productJsonArr"></alaef-eps-chart>
      </div>
      <!-- div v-else-if="selectedType === 'aladin'">
        <aladin-chart @isChartLoading="updateIsChartLoading" :tz="selectedTZ" :height="selectedHeight" :vars="checkedVars" :json_station="stationMeta" :json_type="selectedType" :json_data_multi="productJsonArr"></aladin-chart>
      </div -->



    </template>

  </div>
</template>

<script>

import SHMUconf from '../../shmu_conf';
import Axios from "axios";
import EcmwfEpsChart from "./ecmwf-eps-chart.vue";
import AlaefEpsChart from "./alaef-eps-chart.vue";
import AladinChart from "./aladin-chart";
import myMixin from './mixin';
import Select2 from '../../components/Select2.vue'
import geoLocationMixin from '../../geoLocationMixin'

export default {
  components: {
    AlaefEpsChart,
    'ecmfw-eps-chart': EcmwfEpsChart,
    'aladin-chart': AladinChart,
    'alaef-chart': AlaefEpsChart,
    'v-select2': Select2,
  },
  mixins: [myMixin, geoLocationMixin],
  name: 'MeteogramsComponent',
  data() {
    return {
      loadingUrl: SHMUconf.SITE_BASE_URL + 'img/loader.gif',
      isError: false,
      errorMsg: null,
      isDataLoaded: false,
      isProductsLoaded: false,
      isJsonLoaded: false,
      isStationsLoaded: false,
      isChartLoading: false,
      isLoading: false,
      stationProductsData: null,
      selectedStation: null,
      defaultStation: 31370,
      selectedType : null,
      selectedRuntime : null,
      selectedHeight: 420,
      selectedTZ: 'local',
      productJson : null,
      productJsonArr : [],
      stations : [],
      lastSelectedType: null,
      vars: [
        {id:'tvzd', name: this.$t('nwp.teplota') },
        {id:'cloud', name: this.$t('nwp.celkova_oblacnost') },
        {id:'cloud_partial', name: this.$t('nwp.oblacnost_vo_vrstvach') },
        {id:'precip', name: this.$t('nwp.zrazky') },
        {id:'snow', name: this.$t('nwp.sneh')  },
        {id:'press', name: this.$t('nwp.tlak')  },
        {id:'wind', name: this.$t('nwp.vietor')  },
        {id:'winddir', name: this.$t('nwp.smer_vetra') },
      ],
      chartHeights: [
        {value:320, name: this.$t('nwp.graf_nizka') },
        {value:420, name: this.$t('nwp.graf_stredna') },
        {value:520, name: this.$t('nwp.graf_vysoka') },
      ],
      checkedVars: [],

    }
  },
  watch: {
    selectedStation(v) {
      this.$ls.set('meteogram_selected_city', v, 365 * 60 * 60 * 1000); // 1 rok
      if (this.selectedType != null) {
        this.lastSelectedType = this.selectedType;
      }
      this.selectedType = null;
      this.selectedRuntime = null;
      this.getStationProductsData(v);
      this.setUrlStationParam(v);
    },
    stations(v) {
      if (v.length && this.selectedStation === null) {
        this.selectedStation = this.defaultStation;
      }
    },
    stationProductsData(v) {
      const self = this;

      if (v && v.data.length === 0) {
        this.isError = true;
        this.errorMsg = 'Meteogramy pre vybrané miesto nie sú momentálne dostupné';
      }

      if (self.selectedType === null && v && v.data.length > 0) {
        if (self.lastSelectedType != null && self.stationProductsTypes.indexOf(self.lastSelectedType) >= 0) {
          self.selectedType = self.lastSelectedType;
        } else {
          self.selectedType = self.stationProductsTypes[0];
        }
      }

    },
    selectedType(v, o) {
      const self = this;
      if (v != null) {
        self.productJson = null;
        self.productJsonArr = [];
        // this.lastSelectedType = v;
        location.hash = v;
        this.selectedRuntime = null;
        this.$nextTick(function () {
          if (typeof self.stationRuntimes !== 'undefined' && self.stationRuntimes.length) {
            self.selectedRuntime = self.stationRuntimes[0];
          }
        })
        this.isChartLoading = true;
      }

    },
    selectedRuntime(v, o) {
      if (v != null) {
        this.productJsonArr = [];
        this.isChartLoading = true;
        if (['aladin', 'ecmwf'].includes(this.selectedType)) { // ak je to aladin alebo ecmwf, nacitavam konkretny json
          this.getJsonDataCustom(this.selectedType);
        } else if (this.selectedType === 'alaef') { // ak je to alaef, nacitam aj aladin, lebo zobrazujem dva produkty v jednom
          this.getJsonDataCustom('alaef');
          this.getJsonDataCustom('aladin');
        }
      }
    },
    checkedVars(v) {
      const self = this;
      this.$nextTick(function() {
        if (v.length === 0) {
          self.checkedVars = self.vars.map((item) => item.id);
        }

        self.$ls.set('meteogram_selected_vars_v3', self.checkedVars);

      })
    },
    selectedHeight(v) {
      this.$ls.set('meteogram_selected_height', v, 365 * 60 * 60 * 1000); // 1 rok
    },
    selectedTZ(v) {
      this.$ls.set('meteogram_selected_tz', v, 365 * 60 * 60 * 1000); // 1 rok
    }

  },
  mounted() {

    if (window.nwp_mesto) {
      this.defaultStation = window.nwp_mesto;
    } else {
      /*
      if (this.$ls.get('meteogram_selected_city')) {
        this.defaultStation = this.$ls.get('meteogram_selected_city');
      }
       */
    }

    if (this.$ls.get('meteogram_selected_height')) {
      // this.selectedHeight = this.$ls.get('meteogram_selected_height');
    }

    if (this.$ls.get('meteogram_selected_tz')) {
      // this.selectedTZ = this.$ls.get('meteogram_selected_tz');
    }

    this.checkedVars = this.vars.map((item) => item.id);
    /*
    if (this.$ls.get('meteogram_selected_vars_v3')) {
      this.checkedVars = this.$ls.get('meteogram_selected_vars_v3');
    } else {
      this.checkedVars = this.vars.map((item) => item.id);
    }
     */

    let h = location.hash;
    if (['#ecmwf', '#aladin', '#alaef'].includes(h)) {
      this.selectedType = h.replace('#', '');
    } else {
      this.selectedType = 'alaef';
    }


    this.getStations();


  },
  computed: {
    stationsOptions() {
      const self = this;
      const rs = this.selectedStation;
      const s = this.stations;
      if (this.stations && this.stations.length > 0) {
        return this.stations.reduce((stations, station) => {
          let sn = station.station_name;
          if (typeof station.distance !== 'undefined') {
            sn += ' ('+station.distance + 'km)';
          }
          stations.push({'id': station.station_id, 'text': sn})
          return stations;
        }, []);
      }
      return [];
    },
    stationMeta: function() {
      if (this.stationProductsData !== null && typeof this.stationProductsData.station !== 'undefined') {
        return this.stationProductsData.station;
      }
      return false;
    },
    stationProductsTypes: function() {
      return [
        //  'alaef', 'aladin', 'ecmwf',
        'alaef', 'ecmwf',
      ];
    },
    stationRuntimes: function() {
      const s_type = this.selectedType; // touch pre typ
      const s_data = this.stationProductsData; // touch pre stationData
      // console.log('stationRuntimes touch');

      let ss_type = s_type;

      if (s_data && ss_type) {
        let r_times_list = s_data.data.filter(item => item.type === ss_type)
        let r_t = r_times_list.map(item => item.runtime)
        if (r_t.length > 5) {
          return r_t.slice(0, 5)
        }
        return r_t;

      }

    },
    defaultSelect2Settings() {
      return {
        allowClear: true,
        width: '100%',
        language: this.select2LangSK,
      }
    },
    select2LangSK() {

      // Slovak

      // use text for the numbers 2 through 4
      var smallNumbers = {
        2: function (masc) {
          return (masc ? 'dva' : 'dve');
        },
        3: function () {
          return 'tri';
        },
        4: function () {
          return 'štyri';
        }
      };

      return {
        errorLoading: function () {
          return 'Výsledky sa nepodarilo načítať.';
        },
        inputTooLong: function (args) {
          var overChars = args.input.length - args.maximum;

          if (overChars === 1) {
            return 'Prosím, zadajte o jeden znak menej';
          } else if (overChars >= 2 && overChars <= 4) {
            return 'Prosím, zadajte o ' + smallNumbers[overChars](true) +
                ' znaky menej';
          } else {
            return 'Prosím, zadajte o ' + overChars + ' znakov menej';
          }
        },
        inputTooShort: function (args) {
          var remainingChars = args.minimum - args.input.length;

          if (remainingChars === 1) {
            return 'Prosím, zadajte ešte jeden znak';
          } else if (remainingChars <= 4) {
            return 'Prosím, zadajte ešte ' +
                smallNumbers[remainingChars](true) + ' znaky';
          } else {
            return 'Prosím, zadajte ešte ďalších ' + remainingChars + ' znakov';
          }
        },
        loadingMore: function () {
          return 'Načítanie ďalších výsledkov…';
        },
        maximumSelected: function (args) {
          if (args.maximum === 1) {
            return 'Môžete zvoliť len jednu položku';
          } else if (args.maximum >= 2 && args.maximum <= 4) {
            return 'Môžete zvoliť najviac ' + smallNumbers[args.maximum](false) +
                ' položky';
          } else {
            return 'Môžete zvoliť najviac ' + args.maximum + ' položiek';
          }
        },
        noResults: function () {
          return 'Nenašli sa žiadne položky';
        },
        searching: function () {
          return 'Vyhľadávanie...';
        },
        removeAllItems: function () {
          return 'Zrušiť výber položky';
        }
      };
    },


  },
  methods: {
    nicename(v) {
      if (v === 'aladin') return 'ALADIN';
      if (v === 'ecmwf') return 'ECMWF';
      if (v === 'alaef') return 'A-LAEF/ALADIN';
      return v;
    },
    getStations() {
      const self = this;
      self.isStationsLoaded = false;

      Axios.get(SHMUconf.API_BASE_URL + 'nwp/getjsonaladinstations', {
        crossDomain: true,
        cache: false,
      }).then((response) => {
        if (!response.data.error) {
          self.stations = response.data
          self.isError = false;
          self.errorMsg = null;
          self.isStationsLoaded = true;
        } else {
          this.isError = true;
          if (response.data.error[0].text) {
            this.errorMsg = response.data.error[0].text;
          } else {
            this.errorMsg = 'Nastala chyba pri načítavaní zoznamu miest!';
          }
        }
        this.isLoading = false;
      }).catch((error) => {
        this.isError = true;
        this.errorMsg = 'Nastala chyba pri komunikácii so serverom!';
        this.isLoading = false;
      });
    },
    getStationProductsData(station_id) {
      const self = this;
      this.isLoading = true;
      this.isProductsLoaded = false;
      this.stationProductsData = null;

      Axios.get(SHMUconf.API_BASE_URL + 'nwp/getstationproducts?station=' + station_id, {
        crossDomain: true,
        cache: false,
      }).then((response) => {
        if (!response.data.error) {
          self.stationProductsData = response.data
          self.isError = false;
          self.errorMsg = null;
          self.isProductsLoaded = true;
        } else {
          this.isError = true;
          if (response.data.error[0].text) {
            self.errorMsg = response.data.error[0].text;
          } else {
            self.errorMsg = 'Nastala chyba pri načítavaní zoznamu miest!';
          }
        }
        this.isLoading = false;

      }).catch((error) => {
        this.isError = true;
        this.errorMsg = 'Nastala chyba pri komunikácii so serverom!';
        this.isLoading = false;
      });
    },
    getJsonData() {
      const self = this;
      this.isJsonLoaded = false;

      if (this.selectedStation && this.selectedRuntime && this.selectedType && this.stationProductsData) {

        let ss_type = this.selectedType;

        let res = this.stationProductsData.data.find(item => (item.type === ss_type && parseInt(item.runtime) === parseInt(this.selectedRuntime)));
        if (res) {
          Axios.get(SHMUconf.SITE_BASE_URL + 'data/datanwp/json/' + res.file_link, {
            crossDomain: true,
            cache: false,
          }).then((response) => {
            self.productJson = response.data
            self.isJsonLoaded = true;
          }).catch((error) => {
            self.isError = true;
            self.errorMsg = 'Nastala chyba pri načítavaní údajov k vybranému meteogramu!';
            console.log(error);
          });
        }
      }
    },
    getJsonDataCustom(type) {
      const self = this;
      this.isJsonLoaded = false;
      if (this.selectedStation && this.selectedRuntime && type && this.stationProductsData) {

        let res = this.stationProductsData.data.find(item => (item.type === type && parseInt(item.runtime) === parseInt(this.selectedRuntime)));
        if (res) {
          Axios.get(SHMUconf.SITE_BASE_URL + 'data/datanwp/json/' + res.file_link, {
            crossDomain: true,
            cache: false,
          }).then((response) => {
            self.productJsonArr.push({ type:type, data:response.data});
            self.isJsonLoaded = true;
          }).catch((error) => {
            self.isError = true;
            self.errorMsg = 'Nastala chyba pri načítavaní údajov k vybranému meteogramu!';
            console.log(error);
          });
        }
      }
    },
    updateIsChartLoading(state) {
      this.isChartLoading = state;
    },
    showDateTimeTZ(value, format) {
      let ttz = 'UTC';
      if (this.selectedTZ !== 'utc') {
        ttz = Intl.DateTimeFormat().resolvedOptions().timeZone
      }
      let momUTC = this.$moment.utc(value);
      return this.$moment.tz(momUTC.clone(), ttz).format(format);
    },
    focusStationInput() {
      let el = document.getElementsByClassName('select2-search__field');
      if (el.length) {
        el[0].focus();
      }
    },
    onLocationError(e) {
      this.locationError(this, e);
    },
    onLocationFoundAndSort(e) {
      this.currentLocation = e.coords;

      if (this.currentLocation !== null) {
        for (let i = 0; i < this.stations.length; i++) {
          this.stations[i]["distance"] = this.calculateDistance(
              this.currentLocation.latitude, this.currentLocation.longitude,
              this.stations[i]["lat"], this.stations[i]["lon"],"K").toFixed(2);
        }

        this.stations.sort(function(a, b) {
          return a.distance - b.distance;
        });

      }


    },
    onLocationFoundAndSelectFirst(e) {
      this.currentLocation = e.coords;

      if (this.currentLocation !== null) {
        for (let i = 0; i < this.stations.length; i++) {
          this.stations[i]["distance"] = this.calculateDistance(
              this.currentLocation.latitude, this.currentLocation.longitude,
              this.stations[i]["lat"], this.stations[i]["lon"],"K").toFixed(2);
        }

        this.stations.sort(function(a, b) {
          return a.distance - b.distance;
        });

        this.selectedStation = this.stations[0].station_id;

      }


    },
    sortByNearestLocations() {
      if (this.isGeolocationEnabled) {
        this.getGeoLocation(this.onLocationFoundAndSort, this.onLocationError)
      }
    },
    selectStationByLocation() {
      if (this.isGeolocationEnabled) {
        this.getGeoLocation(this.onLocationFoundAndSelectFirst, this.onLocationError)
      }
    },
    setUrlStationParam(v) {
      const searchURL = new URL(window.location);
      searchURL.searchParams.set('nwp_mesto', v);
      window.history.pushState({}, '', searchURL);
    }


  },
  beforeDestroy() {

  }
}
</script>

<style scoped lang="scss">
.vel-box {
  display: flex;
  align-items: flex-start;
  margin-top: 0.5rem;
  input, label {
    display: block;
  }
  label {
    width: auto !important;
    float: none !important;
    line-height: 1.25 !important;
    padding-right: 25px !important;
    padding-top: 2px !important;
  }
  input {
    margin: 0 10px 0 0 !important;
  }
}

.meteogram-btn {
  padding: 10px 30px !important;
  margin: 5px 5px !important;
  min-width: 170px;
}

.box-vars {
  margin-top: 10px;
  label {
    width: unset !important;
    float: unset !important;
    margin-right: 8px;
    line-height: 2 !important;
    padding-top: 4px;

  }
}

</style>
